import * as React from 'react';
import { FileText } from 'react-feather';
import { Box } from '../components';
import { CloseButtonZero } from './modal/Elements';

type ListItemProps = {
  listItemText: string | null;
  onClick: () => void;
};
const ListItem: React.FC<ListItemProps> = (props) => {
  return (
    <Box height="40px" width="250px" flexDirection="row" mb={2}>
      <div style={{ alignItems: 'center', justifyContent: 'center', marginTop: '15px', textAlign: 'center' }}>
        <FileText size={25} color="#9EA1A5" />
      </div>
      <div style={{ marginTop: '20px', marginLeft: '2px' }}>{props.listItemText}</div>
      <div style={{ position: 'absolute', right: 0, top: 0, marginLeft: '30px', backgroundColor: 'red' }}>
        <CloseButtonZero onClick={props.onClick} />
      </div>
    </Box>
  );
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/ListItem.tsx